module.exports = __webpack_public_path__ + "static/img/h2-18.1ac3759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/h2-18.png
// module id = TDlm
// module chunks = 1